import { useState } from "react";
import FamilyMap from "@/components/map/FamilyMap";
import WorkoutTracker from "@/components/map/WorkoutTracker";
import TracksList from "@/components/map/TracksList";

const TABS = [["family", "Семья"], ["tracker", "Тренировка"], ["tracks", "Маршруты"]];

export default function MapPage() {
  const [tab, setTab] = useState("family");
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <div className="fade-in" data-testid="map-page">
      <div className="mb-6">
        <p className="text-xs uppercase tracking-widest text-muted-foreground mb-1">GPS и геолокация</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-extrabold tracking-tight">Карта</h1>
      </div>
      <div className="flex items-center gap-2 mb-5" data-testid="map-tabs">
        {TABS.map(([id, label]) => (
          <button key={id} onClick={() => setTab(id)} data-testid={`map-tab-${id}`}
            className={`px-3.5 py-1.5 rounded-full text-xs font-semibold transition-colors ${tab === id ? "bg-primary text-white" : "bg-secondary text-muted-foreground hover:text-foreground"}`}>
            {label}
          </button>
        ))}
      </div>
      {tab === "family" && <FamilyMap />}
      {tab === "tracker" && <WorkoutTracker onSaved={() => { setRefreshKey((k) => k + 1); setTab("tracks"); }} />}
      {tab === "tracks" && <TracksList refreshKey={refreshKey} />}
    </div>
  );
}
